import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalConfigurationInstanceDetail extends BaseModelAPI {
	static entity = 'approvalconfigurationinstancedetail';
	static entityName = 'approvalconfigurationinstancedetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.approvalConfigurationInstanceId = '';
			this.approvalConfigurationInstance = {};
			this.approverTypeId = '';
			this.approverType = {};
			this.approvalStructureId = '';
			this.approvalStructure = {};
			this.approverLevel = 0;
			this.approverUserNameId = '';
			this.approverUserName = {};
			this.storedProcedureName = '';
			this.approvalType = '';
			this.configurationContent = '';
			this.isSendNotification = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}